var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.45833 6.99984C3.84752 6.99984 2.54167 5.69399 2.54167 4.08317C2.54167 2.47235 3.84752 1.1665 5.45833 1.1665C7.06915 1.1665 8.375 2.47235 8.375 4.08317C8.375 5.69399 7.06915 6.99984 5.45833 6.99984ZM1.375 11.6665V12.2498C1.375 12.572 1.63616 12.8332 1.95833 12.8332H8.95833C9.28051 12.8332 9.54167 12.572 9.54167 12.2498V11.6665C9.54167 10.3778 8.49703 9.33317 7.20833 9.33317H3.70833C2.41963 9.33317 1.375 10.3778 1.375 11.6665ZM13.0417 6.4165H11.875V5.24984C11.875 4.92743 11.6141 4.6665 11.2917 4.6665C10.9693 4.6665 10.7083 4.92743 10.7083 5.24984V6.4165H9.54167C9.21926 6.4165 8.95833 6.67743 8.95833 6.99984C8.95833 7.32225 9.21926 7.58317 9.54167 7.58317H10.7083V8.74984C10.7083 9.07225 10.9693 9.33317 11.2917 9.33317C11.6141 9.33317 11.875 9.07225 11.875 8.74984V7.58317H13.0417C13.3641 7.58317 13.625 7.32225 13.625 6.99984C13.625 6.67743 13.3641 6.4165 13.0417 6.4165Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.ad250cd46add8627ca70067aa46e0aac.svg";
export { ForwardRef as ReactComponent };